//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InPathEventDataBuilderList.js";
import "../CAM/CAM.WedmPointDefinitionBuilder.js";
import "../CAM/CAM.TabPointDataBuilderList.js";
import "../no/ObjectList.js";
let d=[[[1,"InpathEventDataList",0,"CAM.InPathEventDataBuilderList",0],[1,"LeadInPoint",0,"CAM.WedmPointDefinitionBuilder",0],[1,"LeadOutPoint",0,"CAM.WedmPointDefinitionBuilder",0],[1,"RetractPoint",0,"CAM.WedmPointDefinitionBuilder",0],[1,"TabPointList",0,"CAM.TabPointDataBuilderList",0],[1,"ThreadHolePoint",0,"CAM.WedmPointDefinitionBuilder",0]],[[[],"CreateTabPointDataBuilder",{R_:{tab_builder:"CAM.TabPointDataBuilder"}},0,0],[[],"CreateInpathEventDataBuilder",{R_:{inpath_data_builder:"CAM.InPathEventDataBuilder"}},0,0]],[]];
SPLM.CAM.WedmCustomBoundaryDataBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.WedmCustomBoundaryDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;